import React, { Component } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { apiEndpoint } from "./../../../../Utils/endpoints";
class TakeAwayUserDetail extends Component {
  state = { selection: "", categories: [] };
  componentDidMount() {
    this.setState({ selection: this.props.match.params.selection });
    this.getCategories();
  }
  render() {
    return (
      <div id="page-container" class="side-trans-enabled">
        <main id="main-container">
          <div class="hero-static d-flex align-items-center">
            <div class="w-100">
              <div class="bg-white">
                <div class="content content-full">
                  <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-4 py-4">
                      <div class="text-center">
                        {/* <p class="mb-2">
                          <img
                            src="assets/img/q-logo-white.png"
                            style={{ background: "#C92127" }}
                          />
                        </p> */}
                        <h1 class="h1 mb-1">Customer Details</h1>
                        <h2 class="h3 font-w400 text-muted mb-3">
                          Get things done with Qhide
                        </h2>
                      </div>
                      <form onSubmit={this.submit}>
                        <div class="py-3">
                          <div class="form-group">
                            <label>Name</label>
                            <input
                              type="text"
                              class="form-control form-control-lg form-control-alt"
                              name="customer_name"
                              required
                              placeholder="Name"
                              onChange={this.handleChange}
                            />
                          </div>
                          <div class="form-group">
                            <label>Email or Mobile Number</label>
                            <input
                              type="text"
                              class="form-control form-control-lg form-control-alt"
                              id="login-username"
                              name="customer_number"
                              required
                              placeholder="Enter email or password"
                              onChange={this.handleChange}
                            />
                          </div>
                          <label>Password</label>
                          <div class="form-group">
                            <input
                              type="password"
                              class="form-control form-control-lg form-control-alt"
                              id="login-password"
                              name="customer_password"
                              required
                              placeholder="Password"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div class="form-group row justify-content-center mb-0">
                          <div class="col-md-6 col-xl-5">
                            <button
                              type="submit"
                              class="btn btn-block "
                              style={{
                                background: "rgb(201, 33, 39)",
                                color: "white",
                              }}
                            >
                              <i class="fa fa-fw fa-sign-in-alt mr-1"></i>{" "}
                              Proceed
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div class="font-size-sm text-center text-muted py-3">
                <strong>CDOXS</strong> ©{" "}
                <span data-toggle="year-copy" class="js-year-copy-enabled">
                  2020
                </span>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data });
  };
  submit = async (e) => {
    e.preventDefault();
    var catId = this.state.categories[0].id;
    const token = localStorage.getItem("token");
    const response = await axios.post(
      apiEndpoint + "take-away/login",
      this.state.data,
      { headers: { Authorization: token } }
    );
    console.log(response);
    if (response.data.status === 200) {
      localStorage.setItem("user_token", "Bearer " + response.data.token);
      window.location.href = `/qr-menu/takeaway/${this.props.match.params.id}/${catId}`;
    } else {
      Swal.fire({
        title: response.data.message,
        icon: "error",
        text: "",
        showConfirmButton: true,
      });
    }
  };
  getCategories = async () => {
    const token = localStorage.getItem("user_token");
    try {
      const response = await axios.get(
        apiEndpoint + "menu/category/" + this.props.match.params.id,
        {
          headers: { Authorization: token },
        }
      );
      localStorage.setItem("firstCatId", response.data.categories[0].id);
      console.log(response);
      this.setState({ categories: response.data.categories });
    } catch (e) {
      console.log(e);
    }
  };
}

export default TakeAwayUserDetail;
